import { render } from "./LanguagesSelect.vue?vue&type=template&id=4acb54f6&scoped=true"
import script from "./LanguagesSelect.vue?vue&type=script&lang=js"
export * from "./LanguagesSelect.vue?vue&type=script&lang=js"

import "./LanguagesSelect.vue?vue&type=style&index=0&id=4acb54f6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acb54f6"]])

export default __exports__